<template>
  <b-modal :no-close-on-backdrop="noCloseOnBackdrop" :ref="'ref_' + values.id" :id="values.id" :size="values.size"
           @hidden="onHidden()"
           @show="onShow()">
    <div slot="modal-title">
      <slot name="title"/>
      <template v-if="!$slots.title">
        {{values.title}}
      </template>
    </div>
    <slot name="body"/>
    <div v-if="values.body" class="modal-body">
      {{values.body}}
      <div v-if="values.description">
        <small>{{values.description}}</small>
      </div>
    </div>
    <div slot="modal-footer">
      <slot name="footer"/>
      <template v-if="!$slots.footer">
        <b-button v-if="values.btnSubmitText"
                  variant="primary" :class="values.btnSubmitButtonClass"
                  data-dismiss="modal" @click='onSubmit()'>
          {{values.btnSubmitText}}
        </b-button>
        <b-button variant="info" @click="onClose()" class="ml-2">{{ $t('global.cancel') }}</b-button>
      </template>
    </div>
  </b-modal>
</template>

<script>
export default {
  mounted() {
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs[`ref_${this.values.id}`].show();
    },
    hide() {
      this.$refs[`ref_${this.values.id}`].hide();
    },
    onHidden() { // always emits after modal is hidden
      this.$emit('onHidden');
    },
    onShow() { // always emits just before modal is shown. cancelable
      this.$emit('onShow');
    },
    onSubmit() {
      this.$emit('onSubmit');
    },
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style scoped>

</style>
